import type { CountryConfig } from './auth-config-types'
import { isEntraIdentityProvider, type IdentityProvider } from './identity-provider'
import { naEntraExternalIdPreproductionConfig } from './auth-configs/na-entra-external-id-preproduction.config'
import { naEntraExternalIdProductionConfig } from './auth-configs/na-entra-external-id-production.config'

const NA_COUNTRIES = new Set(['US', 'CA', 'MX'])

export function isNorthAmericaCountry(countryUpper: string): boolean {
	return NA_COUNTRIES.has(countryUpper)
}

export function getNaEntraCountryConfig(
	environment: string,
	country: string,
	language: string
): CountryConfig | undefined {
	const normalizedCountry = country.toUpperCase()
	const normalizedLanguage = language.toLowerCase()
	if (!NA_COUNTRIES.has(normalizedCountry)) {
		return undefined
	}
	const slice =
		environment === 'Production'
			? naEntraExternalIdProductionConfig
			: environment === 'Preproduction'
			? naEntraExternalIdPreproductionConfig
			: undefined
	if (!slice) {
		return undefined
	}
	const byLang = slice[normalizedCountry as keyof typeof slice]
	return byLang?.[normalizedLanguage as keyof typeof byLang] as CountryConfig | undefined
}

export function shouldUseNaEntraStaticMaps(
	identityProvider: IdentityProvider,
	environment: string,
	country: string
): boolean {
	return (
		isEntraIdentityProvider(identityProvider) &&
		(environment === 'Production' || environment === 'Preproduction') &&
		isNorthAmericaCountry(country.toUpperCase())
	)
}
